module.exports = __webpack_public_path__ + "ad859e5325c38e44ceef49ef9dd35a8f.png";